import vm from '~/main'

export default [
  {
    path: 'chat',
    component: () => import('~/views/template/ViewsTemplateMain.vue'),
    meta: {
      breadCrumbLocalStorage: 'translations',
      breadCrumb: (translation) => translation.pages.chat.all.chat,
      headerSecondDisable: true,
      // access: { abilities: ['view_free_documents'] },
    },
    children: [
      {
        path: '',
        name: 'chat',
        component: () => import('~/views/chat/chat.vue'),
        meta: {
          responsive: true,
        },
      },
      {
        path: ':id',
        name: 'chatById',
        component: () => import('~/views/chat/chat.vue'),
        meta: {
          // breadCrumbGetter: 'freeDocumentsGroups/freeDocumentsGroupsShow',
          breadCrumb: () => {
            const chatData = vm.$store.getters['chat/chatsListFormatted'].find((i) => i.id == vm.$route.params.id)
            return chatData && chatData.displayData ? chatData.displayData.name : null
          },
          responsive: true,
        },
      },
    ],
  },
]
